import React from 'react';
import clsx from 'clsx';
import styles from './EventCalendarWrapper.module.scss';
import { hasPastDays, isSelectable } from './utils';
import { EventCalendarWeek } from './EventCalendarWeek';
export const EventCalendarWrapper = ({ months, localSelection, onSelect, dayEventPropsMap, handleRefPopulate, monthlySummary, }) => {
    return (<>
      {months.map((month, i) => {
            const key = month.weeks[1][0].dateTime.toFormat('MMM yyyy'); // weeks[0] - can be a preceding day
            return (<div id={key} key={key} ref={(el) => handleRefPopulate(el, i)} className={clsx(styles.eventCalendarMonth, hasPastDays(month.weeks) && styles.eventCalendarMonthPast)}>
            {month.weeks.map((week) => {
                    const { dateTime, dayPosition } = week[0];
                    const key = `${dateTime.toISO()}-${dayPosition}-week`;
                    return (<EventCalendarWeek key={key} week={week} selection={localSelection} isSelectable={isSelectable} onSelect={onSelect} dayEventPropsMap={dayEventPropsMap} monthlySummary={monthlySummary}/>);
                })}
          </div>);
        })}
    </>);
};
export const MemoizedCalendarWrapper = React.memo(EventCalendarWrapper);
